import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog } from '@yola/ws-ui';

function DifmErrorDialog({ captions, onDismiss }) {
  return (
    <AlertDialog height="auto" glyph="alert-circle" captions={captions} onDismiss={onDismiss} />
  );
}

DifmErrorDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    dismiss: PropTypes.string.isRequired,
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default DifmErrorDialog;
